// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__plEGk","newExpiryDate":"styles_newExpiryDate__31TR-","footer":"styles_footer__1RQBk"};